module.exports = __webpack_public_path__ + "static/media/anjum4.646a1f92.jpeg";